// src/modules/permisos/pages/CalendarioEquipoPage.jsx
// Version de pagina completa del calendario del dashboard (permisos +
// coordinaciones) — mismo componente, con mas espacio y las vistas
// mes/semana/dia habilitadas via la prop fullPage.
import React from "react";
import { Box, Paper } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import { useAuth } from "../../../context/AuthContext";
import DashboardCalendarioWidget from "../components/DashboardCalendarioWidget";

export default function CalendarioEquipoPage() {
  const { user } = useAuth();

  return (
    <DashboardLayout>
      <PageHeader title="Calendario" subtitle="Permisos y coordinaciones del equipo" />
      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <Paper variant="outlined" sx={{ p: { xs: 1.5, md: 2.5 } }}>
          <DashboardCalendarioWidget sucursal={user?.sucursal} fullPage />
        </Paper>
      </Box>
    </DashboardLayout>
  );
}
